<mat-horizontal-stepper linear="true" #stepper>
  <mat-step>
    <ng-template matStepLabel>Select Implement To Inspect</ng-template>
    <div *ngIf="loadingImplmentsToSelect" style="   margin-left: 40%; margin-top:20px; margin-bottom: 20px;">
      <mat-spinner></mat-spinner>
    </div>
    <div style="margin:5px; background-color: #F5F8FB;" class="panel" *ngIf="equipmentDetails != null && !isInventory">
      <div class="panel__header">
        <span class="panel__header__title">
          Equipment Details
        </span>
      </div>
      <div class="panel__content flex flex--align-center">
        <div class="overall-eval-container">
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
          <div class="bold  margin-r--24 {{getEvalClass(equipmentDetails.PercentWorn)}}"
            style=" font-size: 65px; border-radius: 4px;color: white;">
            {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
          </div>
        </div>
        <div class="column-container flex-grow">
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Customer
              </span>
              <span class="text-block__important">
                {{equipmentDetails.CustomerName}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Job Site
              </span>
              <span class="text-block__important">
                {{equipmentDetails.JobsiteName}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Serial Number
              </span>
              <span class="text-block__important">
                <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.SerialNumber}} </a>
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Unit Number
              </span>
              <span class="text-block__important">
                <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.UnitNumber}} </a>
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Last Inspection Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.LastInspectionDate}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Next Inspection Date
              </span>
              <span class="text-block__important">
                {{ equipmentDetails.NextInspectionDate }}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Meter Reading (SMU)
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Smu}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Life to Date (LTD)
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Ltd}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Make
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Make}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Model
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Model}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Family
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Family}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Setup Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.EquipmentSetupDate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="implementBreifViews?.length  ==  0"> There is no implements on this Equipment Please Check again. </div>
    <div [hidden]='selectImplmentListLocked'>
      <mat-selection-list #implmentSelectionList>
        <mat-list-option *ngFor="let implement of implementBreifViews" [value]='implement'
          [selected]='implement === selectedImplement' (click)="selectImplment(implement)">

          <span matLine>
            <img class="implement-photo__photo" style="float: left !important;"
              [src]="getImage(implement.ImplementsImage)" />
            {{implement.ImplementSerialNumber}}
            <span *ngIf="implement.AvailableShematics?.length > 0">
              <span *ngFor="let shematic of implement.AvailableShematics">
                <img *ngIf="shematic.Image != ''" class="implement-photo__photo" [src]="getImage(shematic.Image)" />
              </span>
            </span>
          </span>

        </mat-list-option>
      </mat-selection-list>
    </div>
    <div style="margin-bottom: 50px;" *ngIf="selectImplmentListLocked && selectedImplement !== undefined">
      <div class="panel">
        <div class="panel__header">
          <span class="panel__header__title">Selected Implement {{selectedImplement.ImplementSerialNumber}} To
            Inspect</span>
          <span> <button style="float:right; margin-right: 50px;" matTooltip="Reselect Implment To Inspect"
              (click)="selectImplmentListLocked = false" mat-icon-button> Unlock <mat-icon aria="unlock">lock_open
              </mat-icon></button> </span>
        </div>
        <div class="panel__content" *ngIf="implementDetail !== undefined && selectImplmentListLocked">
          <div class="flex flex--align-center">
            <div id="data-percentageRemaining" class="bold font-size--xl margin-right-24">
              {{implementDetail.condition}}%
            </div>
            <div class="column-container flex-grow">
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    Customer
                  </span>
                  <span class="text-block__important">
                    {{implementDetail.customer}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    Job Site
                  </span>
                  <span class="text-block__important">{{implementDetail.jobsite}}</span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    Make
                  </span>
                  <span class="text-block__important">
                    {{implementDetail.make}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    Model
                  </span>
                  <span class="text-block__important">{{implementDetail.model}}</span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    Life (hrs)
                  </span>
                  <span class="text-block__important">
                    {{implementDetail.life}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    Type
                  </span>
                  <span class="text-block__important">{{ implementDetail.implementType }}</span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    Serial Number
                  </span>
                  <span class="text-block__important">
                    {{implementDetail.serialNo}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    Last Inspection
                  </span>
                  <span class="text-block__important">{{implementDetail.lastInspection}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fix-control-area">
      <button style="float:right;" matStepperNext mat-raised-button color="warn" (click)="nextStep(stepper)"
        [disabled]="selectedImplement === undefined || !selectImplmentListLocked">
        Next
        <i class="material-icons"> keyboard_arrow_right</i>
      </button>
    </div>

  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Implement Information </ng-template>
    <div class=" flex-containers" style="margin-bottom: 8%">

      <implement-inspection-section [isCreatingInspection]='true' [UnitNumber]="unitNumber"  [EquipmentID]="equipmentId" #implementInspection>
      </implement-inspection-section>
    </div>

    <!--<div class="fix-control-area">
      <button style="float:right;" [class.loading]="saving" matStepperNext mat-raised-button color="warn"
        (click)="SaveInspection()" [disabled]="selectedImplement === undefined || !selectImplmentListLocked">
        Save
        <i class="material-icons">done_outline</i>
      </button>
    </div>-->
  </mat-step>
</mat-horizontal-stepper>
